module.exports = __webpack_public_path__ + "img/app-item-upload.198ce5fd.svg";